<template>
  <div id="drama">
    <VideoModal
      ref="video"
      v-if="video_visible"
      :videoUrl="videoUrls"
      :video_item="video_items"
      :isShow="video_visible"
      @setShow="getShow"
    />
    <a-tabs
      :default-active-key="isAuthority"
      class="dramaView"
      @change="changeTab"
    >
      <a-tab-pane :key="0" :style="{ height: viewH + 'px' }">
        <span slot="tab">
          <a-badge :count="0" :offset="[8, -3]"> 基本信息 </a-badge>
        </span>
        <div style="padding: 10px">
          <a-row class="flex mb_20">
            <!-- <a-col :span="2"> -->
            <span class="title">产品名称：</span>
            <!-- </a-col> -->
            <a-col :span="20">
              <span :style="{ color: audit_5.length ? 'blue' : false }"
                >{{ script_info.works_name }}
              </span>
              <!-- <a style="margin-left:5px" v-if="!paramsVal.type" @click="isShowModal">审核</a> -->
              <!-- <a v-else >{{ script_info.works_name }} </a> -->
            </a-col>
          </a-row>
          <a-row class="flex mb_20" v-if="!paramsVal.isAudit">
            <span class="title">作者信息：</span>
            <a-col :span="20"> {{ script_info.writer_info }} </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">监制信息：</span>

            <a-col :span="20"> {{ script_info.supervisor_info }} </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">美术设计：</span>

            <a-col :span="20"> {{ script_info.artist_info }} </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">男生人数：</span>

            <a-col :span="20"> {{ script_info.boy_number }} </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">女生人数：</span>

            <a-col :span="20"> {{ script_info.girl_number }} </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">机制类型：</span>
            <a-col :span="20">
              {{ script_info.mechanism_type_name }}
            </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">推理类型：</span>
            <a-col :span="20">
              {{ script_info.inference_type_name }}
            </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">题材：</span>

            <a-col :span="20"> {{ script_info.theme_type_name }} </a-col>
          </a-row>
          <a-row class="flex mb_20">
            <span class="title">元素：</span>

            <a-col :span="20"> {{ script_info.element_type_name }} </a-col>
          </a-row>
        </div>
      </a-tab-pane>
      <a-tab-pane
        :key="1"
        :style="{ height: viewH + 'px' }"
        force-render
        class="dramaWord"
      >
        <span slot="tab">
          <a-badge
            :count="
              authority.indexOf('1') != -1 ? viewData.manuals_unusual_count : 0
            "
            :offset="[8, -3]"
          >
            <span :class="{ bigTabs: authority.indexOf('1') != -1 ? true : '' }"
              >文本素材({{ script_manuals.length }})</span
            >
          </a-badge>
        </span>
        <!-- <a-tabs
          :default-active-key="script_manuals[0].id"
          type="card"
          @change="subChange"
        >
          <a-tab-pane :key="item.id" v-for="item in script_manuals">
            <span slot="tab">
              <a-badge :count="item.unusual_count" :offset="[6, -3]">
                {{ item.manual_name + "(" + item.count + ")" }}
              </a-badge>
            </span>
          </a-tab-pane>
        </a-tabs> -->
        <a-tabs
          :activeKey="wordid + '_' + material_id"
          type="card"
          @change="subChange"
        >
          <a-tab-pane
            :key="index + '_' + item.id"
            v-for="(item, index) in script_manuals"
          >
            <span slot="tab">
              <a-badge
                :count="authority.indexOf('1') != -1 ? item.unusual_count : 0"
                :offset="[6, -3]"
              >
                {{ item.manual_name }}
              </a-badge>
            </span>
            <div
              style="font-size: 24px"
              :id="'wordView' + item.id"
              @mouseup="authority.indexOf('1') != -1 ? handleMouseSelect() : ''"
              v-html="item.content"
            />
          </a-tab-pane>
        </a-tabs>
        <a-modal
          title="修改意见"
          :visible="visible"
          :confirm-loading="confirmLoading"
          :okText="'确定'"
          :cancelText="'取消'"
          @ok="handleOk"
          @cancel="visible = false"
          :width="800"
        >
          <div class="flex mb_20" v-if="isDelFlag">
            <span>合议类型：</span>
            <a-radio-group v-model="is_delete">
              <a-radio :value="1"> 建议删除 </a-radio>
              <a-radio :value="0"> 建议修改 </a-radio>
            </a-radio-group>
          </div>
          <div v-if="!is_delete">
            <div class="flex mb_20" v-if="modalFlag">
              <span style="width: 120px; margin: auto 0">异常内容</span>
              <a-input
                :disabled="
                  errorVal_edit || changeTabIndex == 1 || changeTabIndex == 2
                "
                v-model="errorVal"
                placeholder="Basic usage"
              />
            </div>
            <div class="flex mb_20">
              <span style="width: 120px; margin: auto 0">一级类目</span>
              <a-select
                v-model="causeVal"
                :defaultValue="causeVal"
                @change="handleChange"
                style="width: 100%; font-size: 24px !important"
              >
                <a-select-option
                  style="font-size: 24px !important"
                  v-for="item in causeList"
                  :key="item.id"
                  :value="item.id + '-' + item.type_name"
                  >{{ item.type_name }}</a-select-option
                >
                <!-- <a-select-option value="2">暴恐</a-select-option>
              <a-select-option value="3">违禁</a-select-option>
              <a-select-option value="4">色情</a-select-option>
              <a-select-option value="5">辱骂</a-select-option>
              <a-select-option value="6">未成年人</a-select-option>
              <a-select-option value="7">其他</a-select-option> -->
              </a-select>
            </div>
            <div class="flex mb_20" v-if="secondList.length">
              <span style="width: 120px; margin: auto 0">二级类目</span>
              <a-select
                v-model="secondVal"
                @change="handleChange1"
                style="width: 100%"
              >
                <a-select-option
                  v-for="item in secondList"
                  :key="item.id"
                  :value="item.id + '-' + item.type_name"
                  >{{ item.type_name }}</a-select-option
                >
                <!-- <a-select-option value="2">暴恐</a-select-option>
              <a-select-option value="3">违禁</a-select-option>
              <a-select-option value="4">色情</a-select-option>
              <a-select-option value="5">辱骂</a-select-option>
              <a-select-option value="6">未成年人</a-select-option>
              <a-select-option value="7">其他</a-select-option> -->
              </a-select>
            </div>
            <div class="flex mb_20">
              <span style="width: 120px">备注说明</span>
              <a-textarea
                v-model="remakeVal"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </div>
            <!-- <div class="flex" v-if="show_is && paramsVal.ass">
              <span>报审机构是否展示：</span>
              <a-radio-group v-model="is_show">
                <a-radio :value="0"> 是 </a-radio>
                <a-radio :value="1"> 否 </a-radio>
              </a-radio-group>
            </div> -->
          </div>
          <div class="flex">
            <span style="width: 120px">建议理由</span>
            <a-textarea
              v-model="discussion_note"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </div>
        </a-modal>
      </a-tab-pane>
      <a-tab-pane :key="2" :style="{ height: viewH + 'px' }">
        <span slot="tab">
          <a-badge
            :count="
              authority.indexOf('2') != -1 ? viewData.pic_unusual_count : 0
            "
            :offset="[8, -3]"
          >
            <span
              :class="{ bigTabs: authority.indexOf('2') != -1 ? true : '' }"
            >
              图片素材({{ script_pic.length }})
            </span>
          </a-badge>
        </span>
        <a-row type="flex" :gutter="[16, 16]">
          <a-col
            :span="8"
            v-for="(item, index) in script_pic"
            :key="index"
            @mouseenter="enter(index)"
            @mouseleave="leave"
            style="margin-bottom: 20px"
          >
            <span class="indexBox">{{ index + 1 }}</span>
            <img
              :style="{
                border:
                  authority.indexOf('2') != -1
                    ? item.check_info.length
                      ? '3px solid red'
                      : '1px solid #ccc'
                    : '',
                position: 'relative',
              }"
              @click="preview(item.url)"
              :src="item.url"
              alt=""
              srcset=""
            />
            <transition
              name="plus-icon"
              v-if="!paramsVal.type && authority2 && viewData.is_labels != 1"
            >
              <p
                style="bottom: -25px; background-color: #1cbbb4"
                class="auditBtn"
                @click="showModal(2, item, 'edit', index)"
                v-if="item.check_info.length"
              >
                <span>修改人工审核信息</span>
              </p>
              <p
                style="bottom: -25px"
                class="auditBtn"
                @click="showModal(2, item, 'add', index)"
                v-else
              >
                <span>添加人工审核信息</span>
              </p>
            </transition>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane :key="3" :style="{ height: viewH + 'px' }">
        <span slot="tab">
          <a-badge
            :count="
              authority.indexOf('3') != -1 ? viewData.video_unusual_count : 0
            "
            :offset="[8, -3]"
          >
            <span
              :class="{ bigTabs: authority.indexOf('3') != -1 ? true : '' }"
            >
              视频素材({{ script_video.length }})
            </span>
          </a-badge>
        </span>
        <a-row type="flex" :gutter="[16, 16]">
          <a-col
            :span="12"
            v-for="(item, index) in script_video"
            :key="index"
            @mouseenter="enter(index)"
            @mouseleave="leave"
            style="margin-bottom: 15px"
          >
            <span class="indexBox">{{ index + 1 }}</span>
            <video
              :style="{
                border:
                  authority.indexOf('3') != -1
                    ? item.check_info.length
                      ? '3px solid red'
                      : ''
                    : '',
                position: 'relative',
              }"
              :id="'videoBox' + index"
              style="width: 100%; position: relative"
              :src="item.url"
              controls="controls"
            ></video>
            <div id="imgOut"></div>
            <transition
              name="plus-icon"
              v-if="!paramsVal.type && authority3 && viewData.is_labels != 1"
            >
              <!-- <p
                class="auditBtn flex_btw"
              >
                <span
                  @click="showModal(3, item)"
                  style="width: 100%; text-align: center"
                  >添加人工审核信息</span
                >
              </p> -->

              <p
                style="
                  bottom: -20px;
                  background-color: #1cbbb4;
                  text-align: center;
                "
                class="auditBtn"
                @click="showVideoModal(item, 'add', index)"
                v-if="item.check_info.length"
              >
                <!-- showModal(3, item, 'edit', index)
                showVideoModal(item,'add',index)
              ) -->
                <span>修改人工审核信息</span>
              </p>
              <p
                style="bottom: -20px; text-align: center"
                class="auditBtn"
                @click="showVideoModal(item, 'add', index)"
                v-else
              >
                <!-- showModal(3, item, 'add', index)
                showVideoModal(item,'add',index)
               -->
                <span>添加人工审核信息</span>
              </p>
            </transition>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane :key="4" :style="{ height: viewH + 'px' }">
        <span slot="tab">
          <a-badge
            :count="
              authority.indexOf('4') != -1 ? viewData.voice_unusual_count : 0
            "
            :offset="[8, -3]"
          >
            <span
              :class="{ bigTabs: authority.indexOf('4') != -1 ? true : '' }"
            >
              音频素材({{ script_voice.length }})
            </span>
          </a-badge>
        </span>
        <a-row type="flex" :gutter="[16, 16]">
          <a-col
            :span="8"
            style="margin-bottom: 10px"
            v-for="(item, index) in script_voice"
            :key="index"
            @mouseenter="enter(index)"
            @mouseleave="leave"
          >
            <span class="indexBox" style="display: block; position: unset">{{
              index + 1
            }}</span>
            <audio
              :style="{
                border:
                  authority.indexOf('4') != -1
                    ? item.check_info.length
                      ? '3px solid red'
                      : ''
                    : '',
              }"
              style="width: 100%; position: relative"
              :src="item.url"
              controls="controls"
            ></audio>
            <transition
              name="plus-icon"
              v-if="!paramsVal.type && authority4 && viewData.is_labels != 1"
            >
              <p
                style="
                  bottom: -20px;
                  background-color: #1cbbb4;
                  text-align: center;
                "
                class="auditBtn"
                @click="showModal(4, item, 'edit', index)"
                v-if="item.check_info.length"
              >
                <span>修改人工审核信息</span>
              </p>
              <p
                style="bottom: -20px; text-align: center"
                class="auditBtn"
                @click="showModal(4, item, 'add', index)"
                v-else
              >
                <span>添加人工审核信息</span>
              </p>
            </transition>
          </a-col>
        </a-row>
      </a-tab-pane>
      <imgModal
        :flag="previewVisible"
        :imgUrl="previewImage"
        @changes="flags"
      />
    </a-tabs>
  </div>
</template>

<script>
import imgModal from "@/components/img_modal";
import VideoModal from "../video_modal";
import $ from "jquery";
import {
  category,
  check_content,
  del_check_info,
  save_edit_content, //审核机构/质检/协会共用修改接口
} from "@/api/organization";
import {
  ass_check_content, //协会审核
  specialist_submit_content, //专家内容审核
  specialist_save_edit_content, //专家合议接口
  specialist_modify, //专家修改内容审核
} from "@/api/association";

export default {
  name: "drama_details",
  props: {
    page: {
      //谁调用了这个组件
      type: String,
      default: "",
    },
    viewData: {
      type: Object,
      default: "",
    },
    violate: {
      //关键词组(暂定)
      type: Array,
      default: function () {
        return [];
      },
    },
    isSelect: {
      //是否可以选择弹窗
      type: Boolean,
      default: "",
    },
    viewHs: {
      //高度
      type: Number,
      default: 0,
    },
    audit_5: {
      //标题审核
      type: Array,
      default: [],
    },
    paramsVal: {
      type: Object,
      default: {},
    },
    authority: {
      //专家传过来的权限
      type: String,
      default: "",
    },
    isAuthority: {
      default: 0,
    },
    specialist_edit: {
      //专家判断是否自己修改
      // default:false
    },
  },
  data() {
    return {
      previewVisible: false, //图片弹窗
      visible: false, //选中文字弹窗
      video_visible: false, //视频审核弹窗
      editVisible: false, //选中文字/图片/视频/音频弹窗修改
      editType: -1, //修改时的文件类型
      modalIndex: -1, //修改素材弹窗起来的index
      errorVal: "", //选中的文字注入输入框
      errorVal_html: "", //选中文字带html标签
      errorVal_edit: false, //输入框判断状态
      errUrl: "", //图片/视频/音频错误链接
      causeVal: "", //一级类目
      causeList: "", //一级类目列表
      secondVal: "", //二级类目
      secondList: "", //二级类目列表
      remakeVal: "", //备注说明
      discussion_note: null, //专家建议
      is_show: 1, //是否展示给报审机构涉意识形态
      show_is: false, //是否显示按钮
      material_id: 0, //手册/音频绑定的id
      wordid: 0, //判断当前是第几个手册
      auditId: 0, //审核内容弹窗的审核id
      checkId: "", //审核类型ID
      confirmLoading: false, //选中文字弹窗_提交按钮
      viewH: "", //tab页动态高度
      previewImage: "", //图片弹窗需要传入的地址
      wordText: "", //读取文档视图
      arr: this.violate, //复用
      modalFlag: true, //区分文档弹窗和图片视频弹窗
      hrefId: "", //判断是否有返回列表按钮
      showIndex: 1, //判断鼠标移入显示
      changeTabIndex: 0, //切换tab页的id
      script_info: this.viewData.script_info, //基础信息
      script_manuals: this.viewData.script_manuals, //文本信息
      script_pic: this.viewData.script_pic, //图片信息
      script_video: this.viewData.script_video, //视频信息
      script_voice: this.viewData.script_voice, //音频信息
      /* 视频子组件 */
      videoUrls: "", //视频url
      video_items: "", //子组件需要的数据和index
      video_file: "", //上传服务器的文件
      video_edit_index: "", //修改弹窗的index
      /* 专家 */
      is_delete: 0, //专家是否建议删除
      authority2: this.authority.indexOf("2") != -1 ? true : false,
      authority3: this.authority.indexOf("3") != -1 ? true : false,
      authority4: this.authority.indexOf("4") != -1 ? true : false,
      isDelFlag: false, //判断弹窗是否显示建议删除
      modal_val: "", //弹窗合议信息用作专家判断
    };
  },
  components: { imgModal, VideoModal },
  created() {
    this.hrefId = window.location.search;
    console.log(window.location.search);
    console.log(this.violate);
    console.log("this.viewData", this.viewData);
    this.isAuthority = this.isAuthority;
    // this.getWordText();
    this.changeTab(this.isAuthority);
    if (this.isAuthority == 1) {
      this.subChange("0_" + this.viewData.script_manuals[0].id);
    }
  },
  mounted() {
    //表格高度自适应
    this.$nextTick(function () {
      this.viewH = document.body.clientHeight - (250 + this.viewHs); //259
      console.log($(".tips"));
    });
    //窗口改变自适应
    window.onresize = () => {
      return (() => {
        this.viewH = window.body.clientHeight - (250 + this.viewHs); //259
      })();
    };
  },
  methods: {
    //获取子组件的显示状态
    getShow(val) {
      this.video_visible = val;
    },
    //切片按钮
    cutBtn(index) {
      // alert(index);
      let scale = 0.25;
      let video = document.getElementById("videoBox" + index);
      let canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.setAttribute("id", "canvas");
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      let imgUrl = canvas.toDataURL("image/jpeg");
      console.log("imgUrl", imgUrl);
      this.preview(imgUrl);
      // document.getElementById("imgOut").append(canvas);
    },
    //预览大图
    preview(url) {
      console.log(this.previewVisible);
      this.previewVisible = true;
      this.previewImage = url;
    },
    //判断是否弹窗
    isShowModal() {
      if (this.audit_5.length) {
        this.$message.info("产品名称已有审核信息");
      } else {
        this.showModal(5, this.script_info.works_name);
      }
    },
    //鼠标移入
    enter(index) {
      // console.log("鼠标移入显示", index);
      this.showIndex = index;
    },
    //鼠标移出
    leave() {
      // console.log("鼠标移出隐藏");
      this.showIndex = 1;
    },
    //
    flags(flag) {
      console.log(flag);
      this.previewVisible = flag;
    },
    //剧本切换tab
    changeTab(val) {
      this.wordid = 0;
      this.material_id = this.script_manuals[0].id;
      this.changeTabIndex = val;
      this.$emit("changeTabs", val);
    },
    //手册切换tab
    subChange(val) {
      console.log("剧本手册切换数据", val);
      this.wordid = val.split("_")[0];
      this.material_id = val.split("_")[1];
      this.$emit("cutSubTab", val.split("_")[1]);
      // this.displayResult()
      // this.getWordText();
    },
    //剧本手册切换数据
    tabClick(item) {
      this.$store.commit("spinning", true);
      console.log("剧本手册切换数据", item);
    },
    //调用文档下载接口
    getCategory(id) {
      category({ id: id })
        .then((res) => {
          console.log(res);
          if (res) {
            if (id) {
              this.secondList = res.data;
            } else {
              this.causeList = res.data;
            }
          } else {
          }
        })
        .catch((err) => {});
    },
    //页面渲染
    displayResult(id, material_id, items) {
      // console.log("resultresultresultresultz",result)
      // let imgReg = /<span.*?(?:>|\/>)/gi;
      // this.highlights(value.replace(imgReg,""));
      console.log("开始渲染页面");
      let content_html = this.errorVal_html;
      let color = "blue";
      if (this.causeVal.indexOf("涉意识形态") != -1) {
        color = "red";
      }
      if (items) {
        let regex = /(<([^>]+)>)/gi;
        let check_conten_replace = items.content_html.replace(regex, "----");
        let check_conten_arr = check_conten_replace.split("----");
        let check_conten_arr_not_null = check_conten_arr.filter(function (s) {
          return s && s.trim();
        });
        check_conten_arr_not_null.map(function (item, index) {
          const reg = new RegExp(
            `<strong style="color: ${
              color == "blue" ? "red" : "blue"
            };">${item}</strong>`,
            "g"
          );
          console.log("item", item);
          // let item_dom = '<strong style="color: red;">' + item + "</strong>"
          let item_dom = `<strong style="color: ${color};">${item}</strong>`;
          console.log("item_dom", item_dom);
          document.getElementById(
            "wordView" + items.material_id + ""
          ).innerHTML = document
            .getElementById("wordView" + items.material_id + "")
            .innerHTML.replace(reg, item_dom);
        });
      } else {
        const reg = new RegExp(content_html, "g");
        document.getElementById("wordView" + material_id + "").innerHTML =
          document
            .getElementById("wordView" + material_id + "")
            .innerHTML.replace(
              reg,
              '<strong style="color: ' +
                color +
                ';">' +
                content_html +
                "</strong>"
            );
      }
    },

    //页面删除渲染
    del_displayResult(items, indexs) {
      console.log("父页面返回的内容", items);
      console.log("父页面返回的items.type", items.type);
      console.log("父页面返回的items.type", this.wordid);
      if (items.type === 1) {
        this.viewData.script_manuals[this.wordid].unusual_count--;
      }
      console.log("父页面返回的items.type", items.material_id);
      if (items.type === 1) {
        let color = "blue";
        if (items.unusual_type_name.indexOf("涉意识形态") != -1) {
          color = "red";
        }
        let regex = /(<([^>]+)>)/gi;
        let check_conten_replace = items.content_html.replace(regex, "----");
        let check_conten_arr = check_conten_replace.split("----");
        let check_conten_arr_not_null = check_conten_arr.filter(function (s) {
          return s && s.trim();
        });
        check_conten_arr_not_null.map(function (item, index) {
          const reg = new RegExp(
            '<strong style="color: ' + color + ';">' + item + "</strong>",
            "g"
          );
          console.log(item);
          console.log(items.material_id);
          document.getElementById(
            "wordView" + items.material_id + ""
          ).innerHTML = document
            .getElementById("wordView" + items.material_id + "")
            .innerHTML.replace(reg, item);
        });
      } else if (items.type === 2) {
        let datas = this.viewData.script_pic;
        datas.map((item, index) => {
          console.log(item);
          if (
            item.check_info.length &&
            item.check_info[0].material_id == items.material_id
          ) {
            this.viewData.script_pic[index].check_info = [];
            return;
          }
        });
      } else if (items.type === 3) {
        let datas = this.viewData.script_video;
        datas.map((item, index3) => {
          console.log(item);
          item.check_info.map((info, index) => {
            // console.log("好几把怪",info)
            if (info.id == items.id) {
              // console.log("确实几把怪")
              this.viewData.script_video[index3].check_info.splice(index, 1);
              // console.log("确实几把怪",this.viewData.script_video[index3])
              // console.log("确实几把怪",this.viewData.script_video[index3].check_info)
              return;
            }
          });
          /* if (
            item.check_info.length &&
            item.check_info[0].material_id == items.material_id
          ) {

          } */
        });
      } else if (items.type === 4) {
        let datas = this.viewData.script_voice;
        datas.map((item, index) => {
          console.log(item);
          if (
            item.check_info.length &&
            item.check_info[0].material_id == items.material_id
          ) {
            this.viewData.script_voice[index].check_info = [];
            return;
          }
        });
      }
    },
    //鼠标选中文字
    handleMouseSelect(event) {
      console.log(event);
      console.log(window.getSelection());
      if (this.paramsVal.type) {
        return;
      }
      const text = document.getSelection().toString();
      let selectionObj = document.getSelection();
      let rangeObj = selectionObj.getRangeAt(0);
      let check_content_obj = rangeObj.cloneContents();
      let tempDiv = document.createElement("div");
      tempDiv.appendChild(check_content_obj);
      let check_content_html = tempDiv.innerHTML;
      let regex = /(<([^>]+)>)/gi;
      let check_conten_replace = check_content_html.replace(regex, "----");
      let check_conten_arr = check_conten_replace.split("----");
      let check_conten_arr_not_null = check_conten_arr.filter(function (s) {
        return s && s.trim();
      });
      let start = check_content_html.indexOf(check_conten_arr_not_null[0]);
      let end_arr = check_conten_arr_not_null.pop();
      let end = check_content_html.indexOf(end_arr);
      let end_length = end_arr.length + end;
      let check_content_html_end = check_content_html.slice(start, end_length); //截取html字符串
      console.log(text);
      console.log(selectionObj);
      console.log(rangeObj);
      console.log(check_content_obj);
      console.log(check_content_html_end);
      this.errorVal_html = check_content_html_end;

      if (!text) {
        this.$message.warning("请选择文章内容");
      } else {
        this.showModal(1, text);
      }
    },
    //确定提交内容审核
    handleOk(e) {
      this.confirmLoading = true;
      // this.confirmLoading = false;
      // console.log("违规内容text：", this.errorVal);
      // console.log("违规内容html：", this.errorVal_html);
      // console.log("一级类目：", this.causeVal);
      // console.log("二级类目：", this.secondVal);
      // console.log("备注：", this.remakeVal);

      if (this.editVisible) {
        this.editCheck();
      } else {
        this.setCheck();
      }
      /* setTimeout(() => {



        this.$emit("auditVal",{ antistop: this.errorVal, cause: "辱骂", remake: "色情图片" })

      }, 2000); */
    },
    //提交内容审核接口
    setCheck() {
      if (!this.remakeVal || !this.discussion_note) {
        this.$message.error({
          content: "请输入备注说明和建议理由！",
          duration: 3,
        });
        this.confirmLoading = false;
        return;
      }
      let data = {
        id: this.viewData.script_info.id,
        type: this.checkId,
        unusual_type: this.causeVal.split("-")[0],
        unusual_type_name: this.causeVal.split("-")[1],
        unusuals_type: this.secondVal.split("-")[0],
        unusuals_type_name: this.secondVal.split("-")[1],
        material_id: this.material_id,
        note: this.remakeVal,
        discussion_note: this.discussion_note,
        is_second: this.viewData.script_info.is_second,
        content:
          this.checkId == 1 || this.checkId == 5 ? this.errorVal : this.errUrl,
        content_html: this.checkId == 1 ? this.errorVal_html : "",
      };
      data.is_show = this.causeVal.indexOf("涉意识形态") != -1 ? 1 : "";
      data.role_id = this.$store.state.user.role_id;
      data.user_id = this.$store.state.user.id;
      data.admin_id = this.viewData.script_info.admin_id;
      data.works_name = this.viewData.script_info.works_name;
      data.user_name = this.$store.state.user.name;
      if (this.checkId == 3) {
        data.fiels = this.video_file;
        const formData = new FormData();
        for (const key in data) {
          const element = data[key];
          formData.append(key, element);
        }
        data = formData;
      }
      specialist_submit_content(data)
        .then((res) => {
          console.log("内容审核返回的内容", res);
          if (res) {
            this.visible = false;
            this.confirmLoading = false;
            this.$message.success({
              content: res.message,
              duration: 3,
            });
            this.secondList = [];
            switch (res.data.type) {
              case 1:
                this.displayResult(res.data.id, this.material_id);
                this.viewData.manuals_unusual_count++;
                this.viewData.script_manuals[this.wordid].unusual_count++;
                break;
              case 2:
                this.viewData.script_pic[this.modalIndex].check_info.push(
                  res.data
                );
                this.viewData.pic_unusual_count++;
                break;
              case 3:
                this.viewData.script_video[this.modalIndex].check_info.push(
                  res.data
                );
                this.viewData.video_unusual_count++;
                break;
              case 4:
                this.viewData.script_voice[this.modalIndex].check_info.push(
                  res.data
                );
                this.viewData.voice_unusual_count++;
                break;
              case 5:
                this.audit_5.push(res.data);
                break;
            }
            this.$emit("setAudit", res.data);
            // this.$emit("upload")
          } else {
            this.confirmLoading = false;
          }
        })
        .catch((err) => {
          this.confirmLoading = false;
        });
    },
    //提交修改内容审核接口
    editCheck() {
      if (!this.remakeVal || !this.discussion_note) {
        this.$message.error({
          content: "请输入备注说明和建议理由！",
          duration: 3,
        });
        this.confirmLoading = false;
        return;
      }
      console.log(this.modal_val);
      console.log(this.discussion_note);
      console.log(this.causeVal.split("-")[0]);
      console.log(this.secondVal.split("-")[0]);
      let note = this.modal_val.quality_note
        ? this.modal_val.quality_note
        : this.modal_val.note;
      let type = this.modal_val.quality_type
        ? this.modal_val.quality_type
        : this.modal_val.unusual_type;
      console.log(note);
      console.log(type);
      if (!this.secondVal) {
        this.$message.error({
          content: "请填写二级类目！",
          duration: 3,
        });
        this.confirmLoading = false;
        return;
      }
      if (
        !this.is_delete &&
        note == this.remakeVal &&
        type == this.causeVal.split("-")[0] + "-" + this.secondVal.split("-")[0]
      ) {
        this.$message.error({
          content: "请修改一二类目或者备注说明！",
          duration: 3,
        });
        this.confirmLoading = false;
        return;
      } else {
        let data = {
          id: this.auditId,
          unusual_type: this.causeVal.split("-")[0],
          unusual_type_name: this.causeVal.split("-")[1],
          unusuals_type: this.secondVal.split("-")[0],
          unusuals_type_name: this.secondVal.split("-")[1],
          note: this.remakeVal,
          discussion_note: this.discussion_note,
          type: this.editType,
          user_id: this.$store.state.user.id,
          admin_id: this.viewData.script_info.admin_id,
          works_name: this.viewData.script_info.works_name,
          user_name: this.$store.state.user.name,
          script_id: this.viewData.script_info.id,
        };
        if (this.paramsVal.specialist && !this.specialist_edit) {
          data.is_delete = this.is_delete;
          if (this.discussion_note == this.remakeVal) {
            this.$info({
              title: "重复提示",
              content: `专家建议理由和备注说明重复，请修改建议理由`,
            });
            this.confirmLoading = false;
          } else {
            specialist_save_edit_content(data)
              .then((res) => {
                console.log("修改审核内容返回", res.data);
                if (res) {
                  this.$message.success(res.message);
                  this.confirmLoading = false;
                  this.visible = false;
                  console.log(this.modalIndex);
                  switch (res.data.type) {
                    case 1:
                      this.displayResult(
                        res.data.id,
                        this.material_id,
                        res.data
                      );
                      break;
                    case 2:
                      this.$emit("setAudit", res.data, "edit", this.audit_5);
                      this.viewData.script_pic[this.modalIndex].check_info[0] =
                        res.data;
                      // this.viewData.script_pic[this.modalIndex].check_info.push(res.data);
                      console.log(this.viewData.script_pic[this.modalIndex]);
                      break;
                    case 3:
                      console.log("这到底是是几", this.video_edit_index);
                      if (this.video_visible) {
                        this.$emit("setAudit", res.data, "edit", this.audit_5);
                        this.$refs.video.editCheck_info(
                          this.video_edit_index,
                          res.data
                        );
                        this.viewData.script_video[this.modalIndex].check_info[
                          this.video_edit_index
                        ] = res.data;
                      } else {
                        this.$emit("setAudit", res.data, "edit", this.audit_5);
                        this.viewData.script_video[
                          this.modalIndex
                        ].check_info[0] = res.data;
                      }
                      break;
                    case 4:
                      this.$emit("setAudit", res.data, "edit", this.audit_5);
                      this.viewData.script_voice[
                        this.modalIndex
                      ].check_info[0] = res.data;
                      break;
                    case 5:
                      this.audit_5.map((item) => {
                        if (item.id == res.data.id) {
                          item = res.data;
                          return;
                        }
                      });
                      break;
                  }
                  this.$emit("setAudit", res.data, "edit", this.audit_5);
                } else {
                  this.$message.error(res.message);
                  this.confirmLoading = false;
                }
              })
              .catch((err) => {
                this.confirmLoading = false;
              });
          }
        } else if (this.specialist_edit) {
          specialist_modify(data)
            .then((res) => {
              if (res) {
                this.$message.success(res.message);
                this.confirmLoading = false;
                this.visible = false;
                console.log(this.modalIndex);
                switch (res.data.type) {
                  case 1:
                    this.displayResult(res.data.id, this.material_id, res.data);
                    break;
                  case 2:
                    this.viewData.script_pic[this.modalIndex].check_info[0] =
                      res.data;
                    // this.viewData.script_pic[this.modalIndex].check_info.push(res.data);
                    console.log(this.viewData.script_pic[this.modalIndex]);
                    break;
                  case 3:
                    console.log("这到底是是几", this.video_edit_index);
                    if (this.video_visible) {
                      this.$emit("setAudit", res.data, "edit", this.audit_5);
                      this.$refs.video.editCheck_info(
                        this.video_edit_index,
                        res.data
                      );
                      this.viewData.script_video[this.modalIndex].check_info[
                        this.video_edit_index
                      ] = res.data;
                    } else {
                      this.viewData.script_video[
                        this.modalIndex
                      ].check_info[0] = res.data;
                    }
                    break;
                  case 4:
                    this.viewData.script_voice[this.modalIndex].check_info[0] =
                      res.data;
                    break;
                  case 5:
                    this.audit_5.map((item) => {
                      if (item.id == res.data.id) {
                        item = res.data;
                        return;
                      }
                    });
                    break;
                }
                this.$emit("setAudit", res.data, "edit", this.audit_5);
              } else {
                this.$message.error(res.message);
                this.confirmLoading = false;
              }
            })
            .catch((err) => {});
        } else {
          (data.is_show = this.is_show),
            (data.role_id = this.$store.state.user.role_id),
            (data.quality_result = this.viewData.script_info.quality_status);
          // data.specialist_result = this.viewData.script_info.specialist_result
          save_edit_content(data)
            .then((res) => {
              console.log("修改审核内容返回", res.data);
              if (res) {
                this.$message.success(res.message);
                this.confirmLoading = false;
                this.visible = false;
                console.log(this.modalIndex);
                switch (res.data.type) {
                  case 1:
                    this.displayResult(res.data.id, this.material_id, res.data);
                    break;
                  case 2:
                    this.viewData.script_pic[this.modalIndex].check_info[0] =
                      res.data;
                    // this.viewData.script_pic[this.modalIndex].check_info.push(res.data);
                    console.log(this.viewData.script_pic[this.modalIndex]);
                    break;
                  case 3:
                    console.log("这到底是是几", this.video_edit_index);
                    if (this.video_visible) {
                      this.$emit("setAudit", res.data, "edit", this.audit_5);
                      this.$refs.video.editCheck_info(
                        this.video_edit_index,
                        res.data
                      );
                      this.viewData.script_video[this.modalIndex].check_info[
                        this.video_edit_index
                      ] = res.data;
                    } else {
                      this.viewData.script_video[
                        this.modalIndex
                      ].check_info[0] = res.data;
                    }
                    break;
                  case 4:
                    this.viewData.script_voice[this.modalIndex].check_info[0] =
                      res.data;
                    break;
                  case 5:
                    this.audit_5.map((item) => {
                      if (item.id == res.data.id) {
                        item = res.data;
                        return;
                      }
                    });
                    break;
                }
                this.$emit("setAudit", res.data, "edit", this.audit_5);
              } else {
                this.$message.error(res.message);
                this.confirmLoading = false;
              }
            })
            .catch((err) => {
              this.confirmLoading = false;
            });
        }
      }
    },
    //弹窗选择异常类型
    handleChange(value) {
      console.log(value);
      this.secondVal = "";
      this.getCategory(value.split("-")[0]);
      if (value.split("-")[1] == "涉意识形态") {
        this.is_show = 1;
        this.show_is = true;
      } else {
        this.is_show = 0;
        this.show_is = false;
      }
    },
    //弹窗选择异常类型1
    handleChange1(value) {
      // this.secondVal = value.split('-')[0];
    },
    //审核内容弹窗
    showModal(type, val, isEdit, index, video_modal_index, isshow) {
      console.log(this.specialist_edit);
      console.log(val);
      console.log("video_items", val);
      this.modal_val = val;
      this.video_file = val.files ? val.files : "";
      this.show_is = false;
      this.errorVal = "";
      this.causeVal = "";
      this.secondVal = "";
      this.remakeVal = "";
      this.discussion_note = null;
      this.secondList = [];
      this.is_delete = 0;
      this.checkId = type;
      this.modalIndex = video_modal_index ? video_modal_index : index;
      this.errorVal_edit = false;
      this.isDelFlag = false;
      // if(isshow){
      this.specialist_edit = isshow;
      // }
      if (isEdit == "edit") {
        this.editVisible = true;
        console.log("+++++++++++++++++++", val);
        if (!this.specialist_edit) {
          this.isDelFlag = true;
        }
      } else {
        this.editVisible = false;
        this.editType = -1;
      }

      this.visible = true;
      this.getCategory();

      if (type == 1) {
        this.modalFlag = true;

        if (isEdit) {
          console.log("-------------------", val);
          this.editType = val.type;
          this.auditId = val.id;
          this.errorVal_edit = true;
          this.errorVal = val.content;
          this.discussion_note = val.discussion_note;
          this.is_delete = val.specialist_result == 2 ? 1 : 0;
          let type = "";
          let type_name = "";
          if (val.specialist_type_name) {
            type = val.specialist_type;
            type_name = val.specialist_type_name;
          } else {
            if (val.quality_type_name) {
              type = val.quality_type;
              type_name = val.quality_type_name;
            } else {
              type = val.unusual_type;
              type_name = val.unusual_type_name;
            }
          }
          //为了满足客户需求多写的垃圾代码
          if (type_name.indexOf("—") != -1) {
            this.causeVal =
              type.split("-")[0] + "-" + type_name.split(" — ")[0];
            this.getCategory(type.split("-")[0]);
            this.secondVal =
              type.split("-")[1] + "-" + type_name.split(" — ")[1];
          } else {
            this.causeVal =
              type.split("-")[0] + "-" + type_name.split(" - ")[0];
            this.getCategory(type.split("-")[0]);
            this.secondVal =
              type.split("-")[1] + "-" + type_name.split(" - ")[1];
          }
          this.remakeVal = val.specialist_note
            ? val.specialist_note
            : val.quality_note
            ? val.quality_note
            : val.note;
        } else {
          this.errorVal = val;
          let index = this.wordid;
          console.log(index);
          this.material_id = this.viewData.script_manuals[index].id;
        }
        if (type_name.indexOf("涉意识形态") != -1) {
          this.show_is = true;
          this.is_show = val.is_show; /*  ? val.is_show : 0 */
        } else {
          this.is_show = 0;
          this.show_is = false;
        }
      } else if (type == 5) {
        this.errorVal_edit = true;
        this.errorVal = val;
        this.material_id = "";
      } else {
        this.modalFlag = false;
        if (isEdit == "edit") {
          let i = 0;
          if (type == 3 && this.video_visible) {
            i = index;
            this.video_edit_index = index;
          }
          this.editType = val.check_info[i].type;
          this.auditId = val.check_info[i].id;
          this.discussion_note = val.val.check_info[i].discussion_note;
          let type_type = "";
          let type_name = "";
          if (val.check_info[i].specialist_type_name) {
            type_type = val.check_info[i].specialist_type;
            type_name = val.check_info[i].specialist_type_name;
          } else {
            if (val.check_info[i].quality_type_name) {
              type_type = val.check_info[i].quality_type;
              type_name = val.check_info[i].quality_type_name;
            } else {
              type_type = val.check_info[i].unusual_type;
              type_name = val.check_info[i].unusual_type_name;
            }
          }
          //为了满足客户需求多写的垃圾代码
          if (type_name.indexOf("—") != -1) {
            this.causeVal =
              type_type.split("-")[0] + "-" + type_name.split(" — ")[0];
            this.getCategory(type_type.split("-")[0]);
            this.secondVal =
              type_type.split("-")[1] + "-" + type_name.split(" — ")[1];
          } else {
            this.causeVal =
              type_type.split("-")[0] + "-" + type_name.split(" - ")[0];
            this.getCategory(type_type.split("-")[0]);
            this.secondVal =
              type_type.split("-")[1] + "-" + type_name.split(" - ")[1];
          }
          this.remakeVal = val.check_info[i].specialist_note
            ? val.check_info[i].specialist_note
            : val.check_info[i].quality_note
            ? val.check_info[i].quality_note
            : val.check_info[i].note;
          if (type_name.indexOf("涉意识形态") != -1) {
            this.show_is = true;
            this.is_show = val.check_info[i].is_show; /*  ? val.is_show : 0 */
          } else {
            this.is_show = 0;
            this.show_is = false;
          }
        } else {
          this.errUrl = val.url;
          this.material_id = val.id;
        }
      }
    },
    //视频审核内容弹窗
    showVideoModal(item, type, index) {
      console.log(item);
      this.video_items = {
        item,
        type,
        index,
      };
      // this.$refs.video.videoUrl = item.url;
      this.videoUrls = item.url;
      this.video_visible = true;
    },
  },
};
</script>

<style lang="less" scoped>
#drama {
  height: 100%;
  background-color: #fff;
  //   overflow: auto;
}
/* .dramaView>.ant-tabs-tabpane{
        // height: 100%;
        overflow: auto;
    } */
.ant-tabs-nav-scroll {
  position: relative;
}
.ant-tabs-bar {
  padding-right: 90px;
}
.title {
  font-weight: bold;
}
.ant-col-12 {
  margin-bottom: 8px;
}
.ant-col-8 {
  // border: 1px solid #333;
  // padding: 8px;
  margin-bottom: 8px;
  text-align: center;
  img {
    max-width: 100%;
    height: 380px;
    // height: 60%;
    cursor: pointer;
    position: relative;
  }
}
.ant-tabs-tabpane {
  height: 500px;
  overflow-y: auto;
  padding: 0 15px;
}
/deep/ .highlights-text {
  color: #ff5134;
}

.border_red {
  border: 2px solid red;
}
.dramaWord {
  .ant-tabs-tabpane-active {
    height: 100%;
    overflow-y: auto;
  }
  .ant-tabs-tabpane {
    padding: 0;
  }
}

.bigTabs {
  font-size: 24px;
  font-weight: bold;
}

.auditBtn {
  position: absolute;
  width: calc(100% - 16px);
  height: 48px;
  line-height: 48px;
  font-size: 24px;
  background-color: #40a9ff;
  color: #fff;
  margin-right: 20px;
  bottom: -37;
  padding-left: 20px;
  &:hover {
    cursor: pointer;
  }
  .cutAudit {
    width: 80px;
    background: rgb(13, 128, 13);
    text-align: center;
  }
}

//css过渡动画效果
.plus-icon-enter-active {
  transition: opacity 0.3s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.3s;
}
.plus-icon-leave-to {
  opacity: 0;
}

.indexBox {
  position: absolute;
  z-index: 99;
  padding: 10px;
  border: 2px solid #333;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 25px;
  font-size: 30px;
  font-weight: bold;
  margin: 10px;
  background: #fff;
  text-align: center;
}
/deep/ .ant-badge {
  font-size: 24px;
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
  height: 50px;
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  height: 50px;
  line-height: 50px;
}

/deep/ .ant-badge-count {
  min-width: 30px;
  height: 30px;
  font-size: 24px;
  line-height: 30px;
  border-radius: 20px;
  right: -2px !important;
  margin-top: 1px !important;
}
/deep/ .ant-scroll-number-only {
  height: 30px;
}
/deep/ .ant-scroll-number-only > p.ant-scroll-number-only-unit {
  height: 30px;
}
/deep/ .ant-btn {
  font-size: 24px;
  height: 48px;
}
/deep/ .ant-modal-body,
/deep/ .ant-modal-header {
  font-size: 24px;
}
/deep/ .ant-radio-wrapper {
  font-size: 24px;
}
/deep/ .ant-input {
  font-size: 24px;
  padding: 5px 10px;
}
/deep/ .ant-select {
  font-size: 24px !important;
}
/deep/ .ant-select-dropdown-menu-item {
  font-size: 24px !important;
}
/deep/ li.ant-select-dropdown-menu-item {
  font-size: 24px !important;
}
// .ant-select-dropdown-menu-item
</style>
